import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { saveProductImages } from "../../../../services/MasterApiServices";

const AddProductImage = ({ productGuid, productList, handleClose, reloadProductList }) => {
  const [selectedProduct, setSelectedProduct] = useState(productGuid || "");
  const [thumbnail, setThumbnail] = useState(null);
  const [detailImage, setDetailImage] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [existingThumbnail, setExistingThumbnail] = useState(null);
  const [existingDetailImages, setExistingDetailImages] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);
  const [description, setDescription] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);

const combinedDetailImages = [
  ...detailImage.map((img, idx) => ({
    type: "new",
    file: img,
    idx,
  })),
  ...existingDetailImages.map((img, idx) => ({
    type: "existing",
    file: img,
    idx,
  }))
];

const handlePrev = () => {
  setCurrentIndex((prev) =>
    prev === 0 ? combinedDetailImages.length - 1 : prev - 1
  );
};

const handleNext = () => {
  setCurrentIndex((prev) =>
    prev === combinedDetailImages.length - 1 ? 0 : prev + 1
  );
};


  useEffect(() => {
    if (productGuid && productList.length > 0) {
      setSelectedProduct(productGuid);
      const foundProduct = productList.find((p) => p.guid === productGuid);
      if (foundProduct && Array.isArray(foundProduct.productImages)) {
        const primary = foundProduct.productImages.find((img) => img.isPrimary);
        const others = foundProduct.productImages.filter((img) => !img.isPrimary);
        setExistingThumbnail(primary || null);
        setExistingDetailImages(others);
      } else {
        setExistingThumbnail(null);
        setExistingDetailImages([]);
      }
const primary = foundProduct.productImages.find((img) => img.isPrimary);
        const others = foundProduct.productImages.filter((img) => !img.isPrimary);
     setDescription(primary?.imgDescription || others[0]?.imgDescription || "");

      setThumbnail(null);
      setDetailImage([]);
      setHasChanges(false);
    }
  }, [productGuid, productList]);

  // 🟢 Clean up object URLs when component unmounts or files change
  // useEffect(() => {
  //   return () => {
  //     if (thumbnail) URL.revokeObjectURL(thumbnail);
  //     detailImage.forEach((file) => URL.revokeObjectURL(file));
  //   };
  // }, [thumbnail, detailImage]);

  const handleThumbnailChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      setThumbnail(null);
      setHasChanges(true);
      return;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = 200;
        canvas.height = 140;
        ctx.drawImage(img, 0, 0, 200, 140);
        canvas.toBlob(
          (blob) => {
            if (!blob) return;
            const resizedFile = new File([blob], file.name, { type: file.type });
            setThumbnail(resizedFile);
            setHasChanges(true);
          },
          file.type || "image/jpeg"
        );
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  };

  const handleDetailImageChange = (event) => {
    const files = Array.from(event.target.files);
    if (detailImage.length + existingDetailImages.length + files.length > 3) {
      toast.error("You can upload a maximum of 3 images.");
      return;
    }

    const resizedImagesPromises = files.map((file) => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = 700;
            canvas.height = 450;
            ctx.drawImage(img, 0, 0, 700, 450);
            canvas.toBlob(
              (blob) => {
                if (blob) {
                  const resizedFile = new File([blob], file.name, { type: file.type });
                  resolve(resizedFile);
                }
              },
              file.type
            );
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      });
    });

    Promise.all(resizedImagesPromises).then((resizedFiles) => {
      setDetailImage((prev) => [...prev, ...resizedFiles]);
      setHasChanges(true);
    });
  };

  const handleRemoveDetailImage = (idx) => {
    setDetailImage((prev) => prev.filter((_, i) => i !== idx));
    setHasChanges(true);
  };

  const handleRemoveExistingDetailImage = (idx) => {
    setExistingDetailImages((prev) => prev.filter((_, i) => i !== idx));
    setHasChanges(true);
  };

  const handleRemoveThumbnail = () => {
    setThumbnail(null);
    setExistingThumbnail(null);
    setHasChanges(true);
  };

//   const handleUpload = async (e) => {
//    if (e) e.preventDefault();
//     const hasDetailImage = detailImage.length > 0 || existingDetailImages.length > 0;
//     if (!selectedProduct || !thumbnail || !hasDetailImage) {
//       toast("Please select product, thumbnail, and at least one detail image");
//       return;
//     }
//     setUploading(true);

//     const formData = new FormData();
//     formData.append("productGuid", selectedProduct);
//     if (thumbnail) {
//       formData.append("thumbimg", thumbnail);
//     }
//     detailImage.forEach((img) => {
//       formData.append("productImages", img);
//     });

// //   //formData.append("description", description);
// // formData.append("imgDescription", description.replace(/<[^>]+>/g, ""));


//   // ✅ Save raw HTML from ReactQuill
//   formData.append("imgDescription", description);

//     console.log("FormData entries:");
//     for (let pair of formData.entries()) {
//       console.log(pair[0] + ": ", pair[1]);
//     }

//     try {
//       await saveProductImages(formData);
//       toast.success("Images uploaded successfully");
//       setThumbnail(null);
//       setDetailImage([]);
//       setHasChanges(false);
//       if (typeof reloadProductList === "function") {
//         await reloadProductList();
//       }
//       handleClose();
//     } catch (error) {
//       toast.error("Upload failed");
//       console.error("Upload failed:", error);
//     } finally {
//       setUploading(false);
//     }
//   };

const handleUpload = async (e) => {
  if (e) e.preventDefault();

  if (!selectedProduct) {
    toast.error("Please select a product.");
    return;
  }
  if (!thumbnail && !existingThumbnail) {
    toast.error("Please upload a thumbnail.");
    return;
  }
  if (detailImage.length + existingDetailImages.length === 0) {
    toast.error("Please upload at least one detail image.");
    return;
  }

  setUploading(true);
  const formData = new FormData();
  formData.append("productGuid", selectedProduct);

  // 1️⃣ Thumbnail
  if (thumbnail) {
    // New thumbnail
    formData.append("thumbimg", thumbnail);
  } else if (existingThumbnail) {
    // Existing thumbnail (send JSON)
    formData.append("existingThumb", JSON.stringify(existingThumbnail));
  }

  // 2️⃣ New detail images
  detailImage.forEach((img) => {
    formData.append("productImages", img);
  });

  // 3️⃣ Existing detail images
  existingDetailImages.forEach((img) => {
    formData.append("existingImages", JSON.stringify(img));
  });

  // 4️⃣ Description
  formData.append("imgDescription", description);

  try {
    await saveProductImages(formData);
    toast.success("Images saved successfully");
    setThumbnail(null);
    setDetailImage([]);
    setHasChanges(false);
    await reloadProductList?.();
    handleClose();
  } catch (err) {
    toast.error("Save failed");
    console.error("Upload failed:", err);
  } finally {
    setUploading(false);
  }
};


  const products = productList || [];
  const base_path = "https://test9-api.exodusvacations.in";

  return (
    <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
      <div
        className="modal-dialog modal-dialog-centered purchase stock-adjust-modal"
        style={{ maxWidth: "1250px", width: "100%" }}
      >
        <div className="modal-content">
          <div className="page-wrapper-new p-0 ">
            <div className="content ">
              <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                  <h4>Add Product Images</h4>
                </div>
                <button type="button" className="close" aria-label="Close" onClick={handleClose}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body custom-modal-body">
                <div className="row">
                  {/* Form Section */}
                  <div className="col-md-5">
                    <form onSubmit={handleUpload}>
                      <div className="form-group mb-3">
                        <label className="form-label fw-bold">Product</label>
                        <div className="form-control-plaintext" style={{ minHeight: 38, fontWeight: 500 }}>
                          {products.length === 0
                            ? "Loading..."
                            : products.find((p) => String(p.guid) === String(selectedProduct))?.name || "Product not found"}
                        </div>
                      </div>
                      <div className="form-group mb-3">
                        <label className="form-label fw-bold">
                          Thumbnail Image{" "}
                          <span className="text-muted" style={{ fontWeight: 400, fontSize: 13 }}>
                            (200px x 160px)
                          </span>
                        </label>
                        <input
                          type="file"
                          accept="image/*"
                          className="form-control"
                          onChange={handleThumbnailChange}
                        />
                        <div style={{ fontSize: 12 }}>
                          {thumbnail
                            ? thumbnail.name
                            : existingThumbnail
                            ? existingThumbnail.imageURL.split("/").pop()
                            : ""}
                        </div>
                      </div>
                      <div className="form-group mb-3">
                        <label className="form-label fw-bold">
                          Product Detail Images{" "}
                          <span className="text-muted" style={{ fontWeight: 400, fontSize: 13 }}>
                            (700px x 450px, max 3)
                          </span>
                        </label>
                        <input
                          type="file"
                          accept="image/*"
                          multiple
                          className="form-control"
                          onChange={handleDetailImageChange}
                          disabled={detailImage.length + existingDetailImages.length >= 3}
                        />
                        <div style={{ fontSize: 12 }}>
                          {detailImage.length > 0
                            ? detailImage.map((img) => img.name).join(", ")
                            : existingDetailImages.map((img) => img.imageURL.split("/").pop()).join(", ")}
                        </div>
                      </div>
                 
                      <div className="form-group mb-3">
                        <label className="form-label fw-bold">
                          Product Description / Features
                          <span className="text-muted" style={{ fontWeight: 400, fontSize: 13 }}>
                            (Add bullets, key points, or detailed info)
                          </span>
                        </label>
                        <ReactQuill
                          theme="snow"
                          value={description}
                          onChange={(value) => {
                            setDescription(value);
                            setHasChanges(true);
                          }}
                          style={{ height: 295, background: "#fff" }}
                        placeholder="Enter product description, features, or key points..."
                        />
                      </div>
                      {/* <div className="modal-footer-btn">
                        <button type="button" className="btn btn-cancel me-2" onClick={handleClose}>
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-submit"
                          disabled={uploading || !hasChanges}
                        >
                          {uploading ? "Uploading..." : "Upload"}
                        </button>
                      </div> */}
                    </form>
                  </div>
                  {/* Image Preview Section */}
                  <div className="col-md-7">
                  {/* Thumbnail Preview */}
<div className="mb-3">
  <label className="fw-bold mb-2">Thumbnail Preview</label>
  <div
    style={{
      position: "relative",
      width: 200,
      height: 140,
      border: "1px solid #eee",
      borderRadius: 8,
    }}
  >
    {thumbnail ? (
      <img
        src={URL.createObjectURL(thumbnail)}
        alt="Thumbnail Preview"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: 8,
        }}
      />
    ) : existingThumbnail ? (
      <img
        src={`${base_path}${existingThumbnail.imageURL}`}
        alt="Existing Thumbnail"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: 8,
        }}
      />
    ) : (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#bbb",
        }}
      >
        No Image
      </div>
    )}

    {(thumbnail || existingThumbnail) && (
      <button
        type="button"
        onClick={handleRemoveThumbnail}
        style={{
          position: "absolute",
          top: 4,
          right: 4,
          background: "#fff",
          border: "none",
          borderRadius: "50%",
          width: 28,
          height: 28,
          boxShadow: "0 1px 4px #0002",
          cursor: "pointer",
        }}
        title="Remove"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    )}
  </div>
</div>

                      {/* First Detail Image (uploaded or existing) */}
    {/* Detail Images Preview */}
<div className="mt-3">
  <label className="fw-bold mb-2">Detail Image Preview</label>

  {combinedDetailImages.length > 0 && (
    <div
      style={{
        position: "relative",
        width: 700,
        height: 450,
        border: "1px solid #eee",
        borderRadius: 8,
        overflow: "hidden",
      }}
    >
      <img
        src={
          combinedDetailImages[currentIndex].type === "new"
            ? URL.createObjectURL(combinedDetailImages[currentIndex].file)
            : `${base_path}${combinedDetailImages[currentIndex].file.imageURL}`
        }
        alt={`Detail Preview ${currentIndex + 1}`}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: 8,
        }}
        
      />

      {/* Remove button */}
      <button
        type="button"
        onClick={() =>
          combinedDetailImages[currentIndex].type === "new"
            ? handleRemoveDetailImage(combinedDetailImages[currentIndex].idx)
            : handleRemoveExistingDetailImage(combinedDetailImages[currentIndex].idx)
        }
        style={{
          position: "absolute",
          top: 8,
          right: 8,
          background: "#fff",
          border: "none",
          borderRadius: "50%",
          width: 28,
          height: 28,
          boxShadow: "0 1px 4px #0002",
          cursor: "pointer",
        }}
        title="Remove"
      >
        <span aria-hidden="true">&times;</span>
      </button>

      {/* Prev Button */}
      {combinedDetailImages.length > 1 && (
        <button
          type="button"
          onClick={handlePrev}
          style={{
            position: "absolute",
            top: "50%",
            left: 8,
            transform: "translateY(-50%)",
            background: "#fff",
            border: "none",
            borderRadius: "50%",
            width: 32,
            height: 32,
            boxShadow: "0 1px 4px #0002",
            cursor: "pointer",
          }}
        >
          ‹
        </button>
      )}

      {/* Next Button */}
      {combinedDetailImages.length > 1 && (
        <button
          type="button"
          onClick={handleNext}
          style={{
            position: "absolute",
            top: "50%",
            right: 8,
            transform: "translateY(-50%)",
            background: "#fff",
            border: "none",
            borderRadius: "50%",
            width: 32,
            height: 32,
            boxShadow: "0 1px 4px #0002",
            cursor: "pointer",
          }}
        >
          ›
        </button>
      )}
    </div>
  )}

  {/* Small dots indicator */}
  {combinedDetailImages.length > 1 && (
    <div className="d-flex justify-content-center mt-2 gap-2">
      {combinedDetailImages.map((_, idx) => (
        <div
          key={idx}
          onClick={() => setCurrentIndex(idx)}
          style={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            background: idx === currentIndex ? "#333" : "#ccc",
            cursor: "pointer",
          }}
        />
      ))}
    </div>
  )}
</div>

{/* Action Buttons under Preview */}
<div className="d-flex justify-content-end mt-3 gap-2">
  <button
    type="button"
    className="btn btn-cancel"
    onClick={handleClose}
  >
    Cancel
  </button>
  <button
    type="submit"
    className="btn btn-submit"
    disabled={uploading || !hasChanges}
    onClick={handleUpload}
  >
    {uploading ? "Uploading..." : "Upload"}
  </button>
</div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProductImage;

// import React, { useEffect, useState } from "react";
// import { saveProductImages } from "../../../services/MasterApiServices";
// import toast from "react-hot-toast";

// const AddProductImage = ({ productGuid, productList, handleClose, reloadProductList }) => {
//   const [selectedProduct, setSelectedProduct] = useState("");
//   const [thumbnail, setThumbnail] = useState(null);
//   const [detailImages, setDetailImages] = useState([]); // new + replaced images
//   const [existingThumbnail, setExistingThumbnail] = useState(null);
//   const [existingDetailImages, setExistingDetailImages] = useState([]); // old untouched
//   const [deletedImageIds, setDeletedImageIds] = useState([]);
//   const [uploading, setUploading] = useState(false);
//   const [hasChanges, setHasChanges] = useState(false);

//   const base_path = "https://DineOutProLounge-api.exodusvacations.in";

//   // Load product images on open
//   useEffect(() => {
//     if (productGuid && productList.length > 0) {
//       setSelectedProduct(productGuid);
//       const found = productList.find((p) => p.guid === productGuid);
//       if (found && Array.isArray(found.productImages)) {
//         const primary = found.productImages.find((img) => img.isPrimary);
//         const others = found.productImages.filter((img) => !img.isPrimary);
//         setExistingThumbnail(primary || null);
//         setExistingDetailImages(others);
//       } else {
//         setExistingThumbnail(null);
//         setExistingDetailImages([]);
//       }
//       setThumbnail(null);
//       setDetailImages([]);
//       setDeletedImageIds([]);
//       setHasChanges(false);
//     }
//   }, [productGuid, productList]);

//   // === Image Resizer ===
//   const resizeImage = (file, width, height) =>
//     new Promise((resolve) => {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         const img = new Image();
//         img.onload = () => {
//           const canvas = document.createElement("canvas");
//           const ctx = canvas.getContext("2d");
//           canvas.width = width;
//           canvas.height = height;
//           ctx.drawImage(img, 0, 0, width, height);
//           canvas.toBlob(
//             (blob) => {
//               if (blob) resolve(new File([blob], file.name, { type: file.type }));
//             },
//             file.type || "image/jpeg"
//           );
//         };
//         img.src = e.target.result;
//       };
//       reader.readAsDataURL(file);
//     });

//   // === Handlers ===
//   const handleThumbnailChange = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     const resized = await resizeImage(file, 200, 160);

//     if (existingThumbnail?.guid) {
//       setDeletedImageIds((prev) => [...prev, existingThumbnail.guid]);
//       setExistingThumbnail(null);
//     }
//     setThumbnail(resized);
//     setHasChanges(true);
//   };

//   const handleAddDetailImages = async (e) => {
//     const files = Array.from(e.target.files);
//     if (existingDetailImages.length + detailImages.length + files.length > 3) {
//       toast.error("You can upload a maximum of 3 images.");
//       return;
//     }
//     const resizedFiles = await Promise.all(files.map((f) => resizeImage(f, 600, 600)));
//     setDetailImages((prev) => [...prev, ...resizedFiles]);
//     setHasChanges(true);
//   };

//   const handleRemoveExistingDetailImage = (idx) => {
//     const removed = existingDetailImages[idx];
//     if (removed?.guid) {
//       setDeletedImageIds((prev) => [...prev, removed.guid]);
//     }
//     setExistingDetailImages((prev) => prev.filter((_, i) => i !== idx));
//     setHasChanges(true);
//   };

//   const handleRemoveNewDetailImage = (idx) => {
//     setDetailImages((prev) => prev.filter((_, i) => i !== idx));
//     setHasChanges(true);
//   };

//   const handleReplaceExistingDetailImage = async (idx, file) => {
//     if (!file) return;
//     const resized = await resizeImage(file, 600, 600);
//     const removed = existingDetailImages[idx];
//     if (removed?.guid) {
//       setDeletedImageIds((prev) => [...prev, removed.guid]);
//     }
//     setExistingDetailImages((prev) => prev.filter((_, i) => i !== idx));
//     setDetailImages((prev) => [...prev, resized]);
//     setHasChanges(true);
//   };

//   const handleRemoveThumbnail = () => {
//     if (existingThumbnail?.guid) {
//       setDeletedImageIds((prev) => [...prev, existingThumbnail.guid]);
//     }
//     setExistingThumbnail(null);
//     setThumbnail(null);
//     setHasChanges(true);
//   };

//   const handleUpload = async (e) => {
//     e.preventDefault();

//     if (!selectedProduct) {
//       toast.error("Please select a product.");
//       return;
//     }
//     if (!thumbnail && !existingThumbnail) {
//       toast.error("Please upload a thumbnail.");
//       return;
//     }
//     if (existingDetailImages.length + detailImages.length === 0) {
//       toast.error("Please upload at least one detail image.");
//       return;
//     }

//     setUploading(true);
//     const formData = new FormData();
//     formData.append("productGuid", selectedProduct);

//     if (thumbnail) formData.append("thumbimg", thumbnail);
//     detailImages.forEach((img) => formData.append("productImages", img));
//     if (deletedImageIds.length > 0) {
//       formData.append("deletedImages", JSON.stringify(deletedImageIds));
//     }

//     try {
//       await saveProductImages(formData);
//       toast.success("Images saved successfully.");
//       await reloadProductList?.();
//       handleClose();
//     } catch (err) {
//       toast.error("Save failed.");
//       console.error(err);
//     } finally {
//       setUploading(false);
//     }
//   };

//   return (
//     <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
//       <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "900px", width: "100%" }}>
//         <div className="modal-content">
//           <div className="modal-header border-0">
//             <h4>{existingThumbnail || existingDetailImages.length ? "Edit" : "Add"} Product Images</h4>
//             <button type="button" className="close" onClick={handleClose}><span>×</span></button>
//           </div>
//           <div className="modal-body">
//             <div className="row">
//               {/* Left Side Form */}
//               <div className="col-md-6">
//                 <form onSubmit={handleUpload}>
//                   <div className="mb-3">
//                     <label className="fw-bold">Product</label>
//                     <div>{productList.find((p) => String(p.guid) === String(selectedProduct))?.name || "Not found"}</div>
//                   </div>

//                   <div className="mb-3">
//                     <label className="fw-bold">Thumbnail (200x160)</label>
//                     <input type="file" accept="image/*" className="form-control" onChange={handleThumbnailChange} />
//                   </div>

//                   <div className="mb-3">
//                     <label className="fw-bold">Detail Images (max 3)</label>
//                     <input
//                       type="file"
//                       accept="image/*"
//                       multiple
//                       className="form-control"
//                       onChange={handleAddDetailImages}
//                       disabled={existingDetailImages.length + detailImages.length >= 3}
//                     />
//                   </div>

//                   <div className="modal-footer-btn">
//                     <button type="button" className="btn btn-cancel me-2" onClick={handleClose}>Cancel</button>
//                     <button type="submit" className="btn btn-submit" disabled={uploading || !hasChanges}>
//                       {uploading ? "Saving..." : "Save"}
//                     </button>
//                   </div>
//                 </form>
//               </div>

//               {/* Right Side Previews */}
//               <div className="col-md-6">
//                 {/* Thumbnail Preview */}
//                 <div className="mb-3">
//                   <label className="fw-bold">Thumbnail Preview</label>
//                   <div style={{ position: "relative", width: 200, height: 140 }}>
//                     {thumbnail ? (
//                       <img src={URL.createObjectURL(thumbnail)} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//                     ) : existingThumbnail ? (
//                       <img src={`${base_path}${existingThumbnail.imageURL}`} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//                     ) : (
//                       <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", color: "#bbb" }}>No Image</div>
//                     )}
//                     {(thumbnail || existingThumbnail) && (
//                       <button onClick={handleRemoveThumbnail} style={{ position: "absolute", top: 4, right: 4 }}>×</button>
//                     )}
//                   </div>
//                 </div>

//                 {/* Detail Images Preview */}
//                 <div className="d-flex gap-2 flex-wrap">
//                   {existingDetailImages.map((img, idx) => (
//                     <div key={`exist-${idx}`} style={{ position: "relative", width: 200, height: 140 }}>
//                       <img src={`${base_path}${img.imageURL}`} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//                       <button onClick={() => handleRemoveExistingDetailImage(idx)} style={{ position: "absolute", top: 4, right: 4 }}>×</button>
//                       <input type="file" accept="image/*" style={{ display: "none" }} id={`replace-${idx}`} onChange={(e) => handleReplaceExistingDetailImage(idx, e.target.files[0])} />
//                       <label htmlFor={`replace-${idx}`} style={{ position: "absolute", bottom: 4, left: 4, background: "#fff", padding: "2px 6px", cursor: "pointer" }}>Replace</label>
//                     </div>
//                   ))}

//                   {detailImages.map((img, idx) => (
//                     <div key={`new-${idx}`} style={{ position: "relative", width: 200, height: 140 }}>
//                       <img src={URL.createObjectURL(img)} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//                       <button onClick={() => handleRemoveNewDetailImage(idx)} style={{ position: "absolute", top: 4, right: 4 }}>×</button>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddProductImage;

